import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Alpha1Set, ModalcolorSet, PromodeSet, Ratio1Set, Color1Set } from "../App";
import { FunkMovebyKey } from "../coreCesium/funcMovebyKey";
import Csv2kml from "../makekml/csv2kml";
import { ButtonAlpha } from "./buttonAlpha";
import { ButtonRatio } from "./buttonRatio";
import { HanreiHigh } from "./hanreiHigh";
import { HanreiNormal } from "./hanreiNormal";
// import { FunkMoveby3Dmouse } from "../aDev/funcMoveby3Dmouse";
import { Cesium1Set } from "../App";


export const MierukaFooter = ({ metadata }) => {
  const [footerview, setFooterview] = useState(true);
  const { ratio1set } = useContext(Ratio1Set);
  const { alpha1set } = useContext(Alpha1Set);
  const { modalcolorset, setModalcolorSet } = useContext(ModalcolorSet);
  const { promodeset, setPromodeSet } = useContext(PromodeSet);
  const { color1set, setColor1Set } = useContext(Color1Set);

  const { cesium1set, setCesium1Set } = useContext(Cesium1Set);

  const handleChangerepeat = () => {
    setFooterview(!footerview);
  };
  const handleChangepromode = () => {
    setPromodeSet(!promodeset);
  };
  const handleModalcolor = () => {
    setModalcolorSet(true);
    // console.log("クリック");
  };
  const params = useParams();

  useEffect(() => {
    setColor1Set([
      metadata.hanrei1_color || "",
      metadata.hanrei2_color || "",
      metadata.hanrei3_color || "",
      metadata.hanrei4_color || "",
      metadata.hanrei5_color || "",
    ]);
}, [promodeset]);


  return (
    <>
      <div
        className={`absolute bottom-0 z-30 pointer-events-none md:rounded-xl bg-blue-500 ${
          footerview ? "animate-fade-in-up" : "animate-fade-in-down"
        }`}
        x-data="app"
      >
        <div className="pointer-events-auto">
          <input
            name="footer"
            id="フッタ表示"
            type="checkbox"
            // value="フッタ表示"
            onChange={handleChangerepeat}
            checked={false == footerview}
            className="peer hidden"
          />
          {footerview ? (
            <label
              htmlFor="フッタ表示"
              className={`block cursor-pointer select-none md:rounded-sm text-center text-xl md:text-3xl lg:text-4xl bg-gray-200 text-black`}
            >
              ▼
            </label>
          ) : (
            <label
              htmlFor="フッタ表示"
              className={`block cursor-pointer select-none md:rounded-sm text-center text-xs md:text-sm lg:text-base peer-checked:bg-blue-500 peer-checked:text-white`}
            >
              ▲表示する
            </label>
          )}
        </div>
      </div>
      <div>
        <div
          className={`absolute bottom-0 left-32 z-30 pointer-events-auto md:rounded-sm bg-blue-500 ${
            footerview ? "animate-fade-in-up" : "animate-fade-in-down"
          }`}
          x-data="app"
        >
          <div className="flex pointer-events-auto">
            {footerview ? (
              <></>
            ) : (
              <>
                <input
                  id="prochk"
                  type="checkbox"
                  onChange={handleChangepromode}
                  checked={promodeset}
                />
                <label
                  htmlFor="prochk"
                  className={`block cursor-pointer md:rounded-sm text-center text-xs md:text-sm lg:text-base bg-blue-500 text-white`}
                >
                  Proモード(開発用であり不具合がありますので使用しないでください)
                </label>
              </>
            )}
          </div>
        </div>
      </div>

      <div
        className={`absolute z-20 bottom-0 min-w-full text-black-900 py-1 text-center bg-gradient-to-r from-white/90 via-white/70 to-white/30 pointer-events-none ${
          footerview ? "animate-fade-in-up" : "animate-fade-out-down"
        }`}
      >
        <div className={`flex md:justify-center w-full pointer-events-none`}>
          <div className="w-7/12 md:w-5/12">
            {promodeset && <HanreiHigh metadata={metadata} />}
            {!promodeset && <HanreiNormal metadata={metadata} />}
          </div>
          <div className="w-1/12 flex justify-center my-auto pointer-events-auto">
            <ButtonRatio />
          </div>

          {promodeset && (
            <div className="w-1/12 flex justify-center my-auto pointer-events-auto">
              <ButtonAlpha />
            </div>
          )}

          {promodeset && (
            <div
              onClick={handleModalcolor}
              className="flex justify-center pointer-events-auto"
            >
              <div
                className="flex justify-center md:rounded-xl bg-gray-200 md:p-2 my-auto mx-4"
                x-data="app"
              >
                <div className="block cursor-pointer select-none md:rounded-xl px-0 md:px-3 py-0 md:py-7 text-center text-sm md:text-base lg:text-xl bold bg-blue-500 text-white">
                  詳細設定
                </div>
              </div>
            </div>
          )}

          {promodeset && <FunkMovebyKey rfcs={cesium1set} />}

          {/* <FunkMoveby3Dmouse rfcs={cesium1set} /> */}
          {/* <FuncMoveby3dHyper rfcs={cesium1set} /> */}

          <div className="w-3/12 md:w-3/12 flex justify-center pointer-events-none">
            <div
              className="flex justify-center md:rounded-xl bg-gray-200 md:p-2 my-auto"
              x-data="app"
            >
              <div className="block cursor-pointer pointer-events-auto select-none md:rounded-xl px-0 md:px-3 py-0 md:py-7 text-center text-sm md:text-base lg:text-xl bold bg-black text-white">
                <Csv2kml
                  meta={metadata}
                  area={params.area}
                  ratio={ratio1set}
                  alpha={alpha1set}
                >
                  <p>
                    Google Earth
                    <span className="hidden md:block">で可視化する</span>
                  </p>
                </Csv2kml>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
